export default "__VITE_ASSET__qlvc$aEs__"